// Generated by scripts/extract_v09_data.py from the checked v0.9 HTML.
// Do not edit this file by hand; update the source record and rerun the script.

import type { Person, Publication, TimelineRecord } from "../types";

export const publications: Publication[] = [
  {
    "id": "10.1016/j.jbusres.2026.116256",
    "year": 2026,
    "type": "international",
    "title": "Free versus paid over-the-top video streaming services and the influence of social media",
    "authors": "Park, Chang Hee · Kim, Jikyung (Jeanne) · Kwak, Youshin · Choi, Jeonghye",
    "venue": "Journal of Business Research 214, 116256",
    "doi": "10.1016/j.jbusres.2026.116256",
    "url": "https://doi.org/10.1016/j.jbusres.2026.116256",
    "featured": true
  },
  {
    "id": "10.1177/10949968251385583",
    "year": 2026,
    "type": "international",
    "title": "The Price of Prestige: When Do Price Premiums Drive or Deter Consumer Demand in Luxury Resale Markets?",
    "authors": "Jung, Hyunwoo · Jo, Wooyong · Choi, Jeonghye",
    "venue": "Journal of Interactive Marketing , Online First",
    "doi": "10.1177/10949968251385583",
    "url": "https://doi.org/10.1177/10949968251385583"
  },
  {
    "id": "10.1108/JRIM-04-2025-0234",
    "year": 2026,
    "type": "international",
    "title": "Weathering the digital shift: How interaction spaces and weather conditions shape mobile app engagement",
    "authors": "Li, Yiling · Choi, Jeonghye · Kim, Jeeyeon",
    "venue": "Journal of Research in Interactive Marketing",
    "doi": "10.1108/JRIM-04-2025-0234",
    "url": "https://doi.org/10.1108/JRIM-04-2025-0234",
    "featured": true
  },
  {
    "id": "10.1177/14413582251356702",
    "year": 2026,
    "type": "international",
    "title": "Push the Paw: A Field Experiment on Personalised Push Notifications and User Engagement",
    "authors": "Kim, Jeeyeon · Kim, Wookyoung · Choi, Jeonghye",
    "venue": "Australasian Marketing Journal 34(1), 76–85",
    "doi": "10.1177/14413582251356702",
    "url": "https://doi.org/10.1177/14413582251356702",
    "featured": true
  },
  {
    "id": "10.1108/JRIM-10-2024-0488",
    "year": 2026,
    "type": "international",
    "title": "Emotional anthropomorphism of notifications and app engagement: does the usage frequency matter?",
    "authors": "Li, Yiling · Hwang, Inseo · Choi, Jeonghye",
    "venue": "Journal of Research in Interactive Marketing 20(1), 91–107",
    "doi": "10.1108/JRIM-10-2024-0488",
    "url": "https://doi.org/10.1108/JRIM-10-2024-0488"
  },
  {
    "id": "10.1093/jcr/ucae075",
    "year": 2025,
    "type": "international",
    "title": "In the Company of Strangers: Social Influence from Anonymous Peers in Online Game Settings",
    "authors": "Jo, Wooyong · Sunder, Sarang · Choi, Jeonghye · Trivedi, Minakshi",
    "venue": "Journal of Consumer Research 52(3), 502–525",
    "doi": "10.1093/jcr/ucae075",
    "url": "https://doi.org/10.1093/jcr/ucae075",
    "featured": true
  },
  {
    "id": "10.1080/02650487.2024.2444857",
    "year": 2025,
    "type": "international",
    "title": "Click, sign-up and purchase: Consumer responses to real-time mobile offers along the consumer decision journey",
    "authors": "Yoon, Yeohong · Kim, Hyejeong · Choi, Jeonghye · Cho, Hyewon",
    "venue": "International Journal of Advertising 44(6), 1040–1065",
    "doi": "10.1080/02650487.2024.2444857",
    "url": "https://doi.org/10.1080/02650487.2024.2444857"
  },
  {
    "id": "10.1007/s11002-024-09736-4",
    "year": 2025,
    "type": "international",
    "title": "A picture’s worth a thousand shares: An empirical analysis of logo sizes in social media posts and their impact on content virality",
    "authors": "Jo, Wooyong · Kim, Hyejeong · Choi, Jeonghye",
    "venue": "Marketing Letters 36(2), 243–257",
    "doi": "10.1007/s11002-024-09736-4",
    "url": "https://doi.org/10.1007/s11002-024-09736-4"
  },
  {
    "id": "10.1057/s41267-024-00756-w",
    "year": 2025,
    "type": "international",
    "title": "Liability of foreignness in immersive technologies: Evidence from extended reality innovations",
    "authors": "Nam, Hyoryung · Li, Yiling · Kannan, P. K. · Choi, Jeonghye",
    "venue": "Journal of International Business Studies 56(3), 422–439",
    "doi": "10.1057/s41267-024-00756-w",
    "url": "https://doi.org/10.1057/s41267-024-00756-w",
    "featured": true
  },
  {
    "id": "10.1177/10949968231189505",
    "year": 2024,
    "type": "international",
    "title": "Surprising Consequences of Innocuous Mobile Transaction Reminders of Credit Card Use on Consumer Spending",
    "authors": "Kim, Jikyung · Yoon, Yeohong · Choi, Jeonghye · Dong, Hang · Soman, Dilip",
    "venue": "Journal of Interactive Marketing 59(2), 135–150",
    "doi": "10.1177/10949968231189505",
    "url": "https://doi.org/10.1177/10949968231189505"
  },
  {
    "id": "10.1016/j.jretconser.2024.103754",
    "year": 2024,
    "type": "international",
    "title": "The impact of offline store presence on digital sales: The moderating role of product functionality",
    "authors": "Kim, Jeeyeon · Choi, Jeonghye · Chang, Sue Ryung · Trivedi, Minakshi",
    "venue": "Journal of Retailing and Consumer Services 78, 103754",
    "doi": "10.1016/j.jretconser.2024.103754",
    "url": "https://doi.org/10.1016/j.jretconser.2024.103754"
  },
  {
    "id": "10.1111/ijcs.13007",
    "year": 2024,
    "type": "international",
    "title": "Older adult consumers and local competition in the healthcare service",
    "authors": "Kim, Jeeyeon · Jo, Wooyong · Kim, Alex Jiyoung · Choi, Jeonghye",
    "venue": "International Journal of Consumer Studies 48(1), e13007",
    "doi": "10.1111/ijcs.13007",
    "url": "https://doi.org/10.1111/ijcs.13007"
  },
  {
    "id": "10.1016/j.techfore.2023.122789",
    "year": 2023,
    "type": "international",
    "title": "Privacy concern and information technology: A meta-analysis",
    "authors": "Kim, Yeolib · Kim, Seung Hyun · Peterson, Robert A. · Choi, Jeonghye",
    "venue": "Technological Forecasting and Social Change 196, 122789",
    "doi": "10.1016/j.techfore.2023.122789",
    "url": "https://doi.org/10.1016/j.techfore.2023.122789"
  },
  {
    "id": "10.1016/j.jbusres.2023.114079",
    "year": 2023,
    "type": "international",
    "title": "A recommendation system with dynamic preferences: Its application in the mobile game industry",
    "authors": "Bae, Joonho · Park, Jinkyoo · Choi, Jeonghye · Soh, Seung Bum",
    "venue": "Journal of Business Research 167, 114079",
    "doi": "10.1016/j.jbusres.2023.114079",
    "url": "https://doi.org/10.1016/j.jbusres.2023.114079"
  },
  {
    "id": "10.1177/10949968221102306",
    "year": 2022,
    "type": "international",
    "title": "Do handwritten notes benefit online retailers? A field experiment",
    "authors": "Kim, Sanghwa · Choi, Jeonghye · Kim, Seung Hyun",
    "venue": "Journal of Interactive Marketing 57(4), 651–664",
    "doi": "10.1177/10949968221102306",
    "url": "https://doi.org/10.1177/10949968221102306"
  },
  {
    "id": "10.1016/j.jbusres.2022.06.051",
    "year": 2022,
    "type": "international",
    "title": "The effect of emotion in thumbnails and titles of video clips on pre-roll advertising effectiveness",
    "authors": "Li, Yiling · Kim, Hye-jin · Do, Boram · Choi, Jeonghye",
    "venue": "Journal of Business Research 151, 232–243",
    "doi": "10.1016/j.jbusres.2022.06.051",
    "url": "https://doi.org/10.1016/j.jbusres.2022.06.051"
  },
  {
    "id": "10.1016/j.jbusres.2022.04.021",
    "year": 2022,
    "type": "international",
    "title": "The effect of social media apps on shopping apps",
    "authors": "Yoon, Jae Yeon · Lee, Chaehyeon · Choi, Jeonghye · Chang, Sue Ryung · Kim, Jikyung",
    "venue": "Journal of Business Research 148, 23–32",
    "doi": "10.1016/j.jbusres.2022.04.021",
    "url": "https://doi.org/10.1016/j.jbusres.2022.04.021"
  },
  {
    "id": "10.1016/j.jbusres.2021.12.055",
    "year": 2022,
    "type": "international",
    "title": "Sentiment change and negative herding: Evidence from microblogging and news",
    "authors": "Kim, Jikyung · Dong, Hang · Choi, Jeonghye · Chang, Sue Ryung",
    "venue": "Journal of Business Research 142, 364–376",
    "doi": "10.1016/j.jbusres.2021.12.055",
    "url": "https://doi.org/10.1016/j.jbusres.2021.12.055"
  },
  {
    "id": "10.1016/j.ijresmar.2021.10.001",
    "year": 2022,
    "type": "international",
    "title": "Opening up OTC drug market: Incumbent firms’ performance and responses to market deregulation",
    "authors": "Jo, Wooyong · Nam, Hyoryung · Choi, Jeonghye",
    "venue": "International Journal of Research in Marketing 39(3), 847–866",
    "doi": "10.1016/j.ijresmar.2021.10.001",
    "url": "https://doi.org/10.1016/j.ijresmar.2021.10.001"
  },
  {
    "id": "10.1111/joca.12389",
    "year": 2021,
    "type": "international",
    "title": "Understanding digital consumers’ well-being in Asia: The moderating roles of digital natives and privacy concern",
    "authors": "Kwak, Youshin · Kim, Jeeyeon · Kim, Yeolib · Choi, Jeonghye",
    "venue": "Journal of Consumer Affairs 55(4), 1274–1291",
    "doi": "10.1111/joca.12389",
    "url": "https://doi.org/10.1111/joca.12389"
  },
  {
    "id": "10.1016/j.jbusres.2019.11.015",
    "year": 2021,
    "type": "international",
    "title": "Channel stickiness in the shopping journey for electronic goods: Evidence from China and South Korea",
    "authors": "Kim, Jikyung · Song, Hyeasinn · Choi, Jeonghye · Kim, Yongseob · Hong, Jeonghan",
    "venue": "Journal of Business Research 130, 506–516",
    "doi": "10.1016/j.jbusres.2019.11.015",
    "url": "https://doi.org/10.1016/j.jbusres.2019.11.015"
  },
  {
    "id": "10.1016/j.indmarman.2020.12.010",
    "year": 2021,
    "type": "international",
    "title": "Buyer-supplier matching in online B2B marketplace: An empirical study of small- and medium-sized enterprises",
    "authors": "Yoon, Yeo Lim · Yoon, Yeohong · Nam, Hyoryung · Choi, Jeonghye",
    "venue": "Industrial Marketing Management 93, 90–100",
    "doi": "10.1016/j.indmarman.2020.12.010",
    "url": "https://doi.org/10.1016/j.indmarman.2020.12.010"
  },
  {
    "id": "10.1108/APJML-05-2019-0317",
    "year": 2021,
    "type": "international",
    "title": "Who are the multichannel shoppers and how can retailers use them? Evidence from the French apparel industry",
    "authors": "Jo, Wooyong · Kim, Jikyung · Choi, Jeonghye",
    "venue": "Asia Pacific Journal of Marketing and Logistics 33(1), 250–274",
    "doi": "10.1108/APJML-05-2019-0317",
    "url": "https://doi.org/10.1108/APJML-05-2019-0317"
  },
  {
    "id": "10.1016/j.jbusres.2019.09.021",
    "year": 2020,
    "type": "international",
    "title": "Purchase now and consume later: Do online and offline environments drive online social interactions and sales?",
    "authors": "Kim, Jikyung · Kim, Sanghwa · Choi, Jeonghye",
    "venue": "Journal of Business Research 120, 274–285",
    "doi": "10.1016/j.jbusres.2019.09.021",
    "url": "https://doi.org/10.1016/j.jbusres.2019.09.021"
  },
  {
    "id": "10.1016/j.jbusres.2019.08.025",
    "year": 2020,
    "type": "international",
    "title": "From clicks to bricks: The impact of product launches in offline stores for digital retailers",
    "authors": "Jiang, Yan · Kim, Jeeyeon · Choi, Jeonghye · Kang, Moon Young",
    "venue": "Journal of Business Research 120, 302–311",
    "doi": "10.1016/j.jbusres.2019.08.025",
    "url": "https://doi.org/10.1016/j.jbusres.2019.08.025"
  },
  {
    "id": "10.1287/mksc.2019.1174",
    "year": 2020,
    "type": "international",
    "title": "Protecting consumers from themselves: Assessing consequences of usage restriction laws on online game usage and spending",
    "authors": "Jo, Wooyong · Sunder, Sarang · Choi, Jeonghye · Trivedi, Minakshi",
    "venue": "Marketing Science 39(1), 117–133",
    "doi": "10.1287/mksc.2019.1174",
    "url": "https://doi.org/10.1287/mksc.2019.1174"
  },
  {
    "id": "10.1080/02650487.2018.1541391",
    "year": 2019,
    "type": "international",
    "title": "The effects of eWOM characteristics on consumer ratings: Evidence from TripAdvisor.com",
    "authors": "Yoon, Yeohong · Kim, Alex Jiyoung · Kim, Jeeyeon · Choi, Jeonghye",
    "venue": "International Journal of Advertising 38(5), 684–703",
    "doi": "10.1080/02650487.2018.1541391",
    "url": "https://doi.org/10.1080/02650487.2018.1541391"
  },
  {
    "id": "10.1080/02650487.2019.1601910",
    "year": 2019,
    "type": "international",
    "title": "The effect of celebrity endorsement on sustainable firm value: Evidence from the Korean telecommunication industry",
    "authors": "Kang, Moon Young · Choi, Yonglim · Choi, Jeonghye",
    "venue": "International Journal of Advertising 38(4), 563–576",
    "doi": "10.1080/02650487.2019.1601910",
    "url": "https://doi.org/10.1080/02650487.2019.1601910"
  },
  {
    "id": "10.1016/j.jbusres.2017.09.022",
    "year": 2019,
    "type": "international",
    "title": "Offline social interactions and online shopping demand: Does the degree of social interactions matter?",
    "authors": "Kim, Jeeyeon · Kim, Mingyung · Choi, Jeonghye · Trivedi, Minakshi",
    "venue": "Journal of Business Research 99, 373–381",
    "doi": "10.1016/j.jbusres.2017.09.022",
    "url": "https://doi.org/10.1016/j.jbusres.2017.09.022"
  },
  {
    "id": "10.1016/j.jbusres.2017.09.047",
    "year": 2019,
    "type": "international",
    "title": "The role of design innovation in understanding purchase behavior of augmented products",
    "authors": "Kim, Sang Jin · Kim, Kyung Hoon · Choi, Jeonghye",
    "venue": "Journal of Business Research 99, 354–362",
    "doi": "10.1016/j.jbusres.2017.09.047",
    "url": "https://doi.org/10.1016/j.jbusres.2017.09.047"
  },
  {
    "id": "10.1509/jmr.13.0482",
    "year": 2017,
    "type": "international",
    "title": "Social interactions and monetary incentives in driving consumer repeat behavior",
    "authors": "Toker-Yildiz, Kamer · Trivedi, Minakshi · Choi, Jeonghye · Chang, Sue Ryung",
    "venue": "Journal of Marketing Research 54(3), 364–380",
    "doi": "10.1509/jmr.13.0482",
    "url": "https://doi.org/10.1509/jmr.13.0482"
  },
  {
    "id": "10.1016/j.intmar.2017.02.001",
    "year": 2017,
    "type": "international",
    "title": "Mobile shopping through applications: Understanding application possession and mobile purchase",
    "authors": "Kim, Mingyung · Kim, Jeeyeon · Choi, Jeonghye · Trivedi, Minakshi",
    "venue": "Journal of Interactive Marketing 39, 55–68",
    "doi": "10.1016/j.intmar.2017.02.001",
    "url": "https://doi.org/10.1016/j.intmar.2017.02.001"
  },
  {
    "id": "10.1016/j.jbusres.2016.07.004",
    "year": 2017,
    "type": "international",
    "title": "Linking online niche sales to offline brand conditions",
    "authors": "Son, Jungmin · Kim, Jikyung · Choi, Jeonghye · Kim, Mingyung",
    "venue": "Journal of Business Research 70, 74–84",
    "doi": "10.1016/j.jbusres.2016.07.004",
    "url": "https://doi.org/10.1016/j.jbusres.2016.07.004"
  },
  {
    "id": "10.1287/mnsc.1110.1447",
    "year": 2012,
    "type": "international",
    "title": "Traditional and IS-enabled customer acquisition on the Internet",
    "authors": "Choi, Jeonghye · Bell, David R. · Lodish, Leonard M.",
    "venue": "Management Science 58(4), 754–769, 2012",
    "doi": "10.1287/mnsc.1110.1447",
    "url": "https://doi.org/10.1287/mnsc.1110.1447"
  },
  {
    "id": "pub-2012-aa7858467c",
    "year": 2012,
    "type": "international",
    "title": "What matters most in Internet retailing",
    "authors": "Bell, David R. · Choi, Jeonghye · Lodish, Leonard M.",
    "venue": "MIT Sloan Management Review 54(1), 27–33, 2012",
    "url": "https://shop.sloanreview.mit.edu/what-matters-most-in-internet-retailing"
  },
  {
    "id": "10.1509/jmkr.48.4.670",
    "year": 2011,
    "type": "international",
    "title": "Preference minorities and the Internet",
    "authors": "Choi, Jeonghye · Bell, David R.",
    "venue": "Journal of Marketing Research 48(4), 670–682, 2011",
    "doi": "10.1509/jmkr.48.4.670",
    "url": "https://doi.org/10.1509/jmkr.48.4.670"
  },
  {
    "id": "10.1509/jmkr.47.1.75",
    "year": 2010,
    "type": "international",
    "title": "Spatiotemporal analysis of imitation behavior across new buyers at an online grocery retailer",
    "authors": "Choi, Jeonghye · Hui, Sam K. · Bell, David R.",
    "venue": "Journal of Marketing Research 47(1), 75–89, 2010",
    "doi": "10.1509/jmkr.47.1.75",
    "url": "https://doi.org/10.1509/jmkr.47.1.75"
  },
  {
    "id": "pub-2026-5018a2f242",
    "year": 2026,
    "type": "domestic",
    "title": "리셀 시장 내 재활용 소재 활용 제품의 가격 프리미엄 형성: 아식스 브랜드"
  },
  {
    "id": "pub-2026-220a680915",
    "year": 2026,
    "type": "domestic",
    "title": "인플루언서 커뮤니케이션이 소비자의 구매 전환에 미치는 영향: 제품 유형과 지역 특성의 조절효과",
    "venue": "경영정보학연구"
  },
  {
    "id": "pub-2026-64b350bb58",
    "year": 2026,
    "type": "domestic",
    "title": "상권 내 유통 채널 경쟁이 PB 판매 성과에 미치는 영향: 편의점-프랜차이즈 슈퍼마켓을 중심으로",
    "venue": "프랜차이징저널"
  },
  {
    "id": "pub-2026-a9c7d365b3",
    "year": 2026,
    "type": "domestic",
    "title": "프랜차이즈 가맹 본부의 위기가 포트폴리오 성과에 미치는 영향 분석",
    "venue": "프랜차이징저널"
  },
  {
    "id": "pub-2025-7d66594c4d",
    "year": 2025,
    "type": "domestic",
    "title": "음식 배달 앱 수용에 대한 사회적 영향력 분석"
  },
  {
    "id": "pub-2025-f2b367ed0d",
    "year": 2025,
    "type": "domestic",
    "title": "메타버스 마케팅과 소비자의 브랜드 참여: 럭셔리 패션 브랜드"
  },
  {
    "id": "pub-2024-371dd85a1f",
    "year": 2024,
    "type": "domestic",
    "title": "가상 인플루언서의 얼굴 특성이 소셜 미디어 이용자 반응에 미치는 영향"
  },
  {
    "id": "pub-2024-1faf92fdcf",
    "year": 2024,
    "type": "domestic",
    "title": "감염병 확산 상황에서 지역별 헬스장 폐업: 위험요인노출과 보상소비지출의 차별적 영향",
    "venue": "마케팅관리연구"
  },
  {
    "id": "pub-2023-ad8afa3f4f",
    "year": 2023,
    "type": "domestic",
    "title": "스포츠 구단 경기 실적·소셜미디어 운영과 팬덤 인게이지먼트"
  },
  {
    "id": "pub-2023-8343abbb61",
    "year": 2023,
    "type": "domestic",
    "title": "Does Proximity Really Matters?"
  },
  {
    "id": "pub-2023-2bd89bff6c",
    "year": 2023,
    "type": "domestic",
    "title": "소비자 신뢰도 향상을 위한 제품 전략의 구전 효과"
  },
  {
    "id": "pub-2023-a7061c5309",
    "year": 2023,
    "type": "domestic",
    "title": "Understanding of the Continuance Intention to Use Chatbot Services"
  },
  {
    "id": "pub-2023-97da7c88bb",
    "year": 2023,
    "type": "domestic",
    "title": "신규 애플리케이션 출시가 기존 시장 생태계에 미치는 영향"
  },
  {
    "id": "pub-2023-f3844e332b",
    "year": 2023,
    "type": "domestic",
    "title": "동영상 콘텐츠 장르·디지털 네이티브·미디어 속성과 사전광고 회피"
  },
  {
    "id": "pub-2023-b30f34b68c",
    "year": 2023,
    "type": "domestic",
    "title": "직장 내 스트레스원과 긍정 정서에 대한 모바일 앱 사용"
  },
  {
    "id": "pub-2022-f4c8de5296",
    "year": 2022,
    "type": "domestic",
    "title": "Who Considers Leaving a Job in a Pandemic?"
  },
  {
    "id": "pub-2022-12ff7a0286",
    "year": 2022,
    "type": "domestic",
    "title": "뉴스 홍보가 시청자 온라인 구전에 미치는 영향"
  },
  {
    "id": "pub-2022-85c9b8a9ea",
    "year": 2022,
    "type": "domestic",
    "title": "숏폼 브랜디드 콘텐츠 노출 유형과 소비자 반응"
  },
  {
    "id": "pub-2022-122967d29c",
    "year": 2022,
    "type": "domestic",
    "title": "The Effect of Lockdown Repeal on Socialization"
  },
  {
    "id": "pub-2022-e7c33c78aa",
    "year": 2022,
    "type": "domestic",
    "title": "간편결제 수용이 쇼핑앱 사용에 미치는 영향"
  },
  {
    "id": "pub-2022-4dbab18602",
    "year": 2022,
    "type": "domestic",
    "title": "온라인 커뮤니티 이용자 참여 증진을 위한 관리자의 운영 전략"
  },
  {
    "id": "pub-2022-d2b54311c9",
    "year": 2022,
    "type": "domestic",
    "title": "동영상 플랫폼 식품 광고 타겟팅 효과"
  },
  {
    "id": "pub-2021-2a63df2e5e",
    "year": 2021,
    "type": "domestic",
    "title": "소셜미디어와 소비자 구매 결정: 서울 공유 자전거"
  },
  {
    "id": "pub-2021-c5cd248b99",
    "year": 2021,
    "type": "domestic",
    "title": "코로나19 상황에서 직무만족도와 모바일 생산활동"
  },
  {
    "id": "pub-2020-3f72b72352",
    "year": 2020,
    "type": "domestic",
    "title": "크래프트 브루어리의 스타트업 전략: 어메이징 브루잉 컴퍼니의 사례를 중심으로",
    "venue": "연세경영연구"
  },
  {
    "id": "pub-2020-2af5eed69c",
    "year": 2020,
    "type": "domestic",
    "title": "건강식품 구매에 제품 네이밍과 고객의 제품 경험, 기업의 제품 판촉이 미치는 영향",
    "venue": "유통연구"
  },
  {
    "id": "pub-2020-a418c8bb81",
    "year": 2020,
    "type": "domestic",
    "title": "날씨불쾌감과 쇼핑선호도가 소매점 선택에 미치는 영향",
    "venue": "유통연구"
  },
  {
    "id": "pub-2018-88b690e9a4",
    "year": 2018,
    "type": "domestic",
    "title": "럭셔리 브랜드의 판매 성과와 제품, 고객, 구색의 영향: 매장 유형의 조절 효과를 중심으로",
    "venue": "유통연구"
  },
  {
    "id": "pub-2016-362e85a08c",
    "year": 2016,
    "type": "domestic",
    "title": "B2B 기업의 마케팅 활동과 고객의 시장 환경이 매출 성과에 미치는 영향",
    "venue": "한국경영과학회지"
  },
  {
    "id": "pub-2016-3079e9f2e3",
    "year": 2016,
    "type": "domestic",
    "title": "온라인 게임 규제와 청소년의 시선: 규제 대상자들의 반발심과 또래문화를 중심으로",
    "venue": "한국콘텐츠학회논문지"
  },
  {
    "id": "pub-2016-f2c72091d9",
    "year": 2016,
    "type": "domestic",
    "title": "지역 특수성에 따른 오프라인·온라인 채널 성과의 이해",
    "venue": "지식경영연구"
  },
  {
    "id": "pub-2016-e278eb422b",
    "year": 2016,
    "type": "domestic",
    "title": "매장 내·외부 환경과 지역 시장 환경이 매장 성과에 미치는 영향",
    "venue": "유통연구"
  },
  {
    "id": "pub-2016-d85260b204",
    "year": 2016,
    "type": "domestic",
    "title": "온라인상의 기업 및 소비자 텍스트 분석과 이를 활용한 온라인 매출 증진 전략",
    "venue": "한국경영과학회지"
  },
  {
    "id": "pub-2016-de69a91f8e",
    "year": 2016,
    "type": "domestic",
    "title": "게임 머니와 캐시 머니 소비에 관한 실증 연구: 경험, 성취, 지역적 격차를 중심으로",
    "venue": "한국콘텐츠학회논문지"
  },
  {
    "id": "pub-2015-ec5f407c64",
    "year": 2015,
    "type": "domestic",
    "title": "소비자의 지역 이주가 온라인 브랜드 선호변화차이에 미치는 영향",
    "venue": "경영학연구"
  },
  {
    "id": "pub-2015-409931a865",
    "year": 2015,
    "type": "domestic",
    "title": "오프라인과 온라인 채널상의 기존제품과 신제품의 판매 성과",
    "venue": "지식경영연구"
  },
  {
    "id": "pub-2015-6cd4dc186d",
    "year": 2015,
    "type": "domestic",
    "title": "오프라인 환경 변화가 틈새 제품의 온라인 수요에 미치는 영향",
    "venue": "마케팅연구"
  },
  {
    "id": "pub-2015-a0ce17c11e",
    "year": 2015,
    "type": "domestic",
    "title": "모바일 VOD 콘텐츠 구매 요인에 관한 실증 연구",
    "venue": "지식경영연구"
  },
  {
    "id": "pub-2014-4506d7664f",
    "year": 2014,
    "type": "domestic",
    "title": "소셜미디어 연구동향 분석: 사회과학 분야를 중심으로",
    "venue": "정보통신정책연구"
  },
  {
    "id": "pub-2014-d66ae6b839",
    "year": 2014,
    "type": "domestic",
    "title": "인터넷 포탈에 대한 자원 의존성이 온라인 쇼핑몰기업의 성장에 미치는 영향",
    "venue": "한국경영과학회지"
  },
  {
    "id": "pub-2014-ba35eb0778",
    "year": 2014,
    "type": "domestic",
    "title": "온라인 게임의 고객 유형별 이탈 요인",
    "venue": "한국경영과학회지"
  },
  {
    "id": "pub-2013-ffb6a4cf5c",
    "year": 2013,
    "type": "domestic",
    "title": "이용자 생산 콘텐츠 플랫폼 사이트 내에서 생산자 참여가 소비자 선택과 몰입에 미치는 차별적 영향",
    "venue": "경영학연구"
  },
  {
    "id": "pub-2020-86480fa228",
    "year": 2020,
    "type": "book",
    "title": "비대면 시대 바르고 건강하게 살기: ‘빠른’을 넘어 ‘바른’ ICT로",
    "venue": "공저, 한국학술정보"
  },
  {
    "id": "pub-2016-c36b810680",
    "year": 2016,
    "type": "book",
    "title": "자동차 자율주행 규제 완화 고용영향평가 연구",
    "venue": "공저, 한국노동연구원"
  },
  {
    "id": "pub-2015-893d8879e1",
    "year": 2015,
    "type": "book",
    "title": "기술혁신에 따른 지역간 정보격차",
    "venue": "공저, 집문당"
  },
  {
    "id": "pub-2013-7ae8a2b798",
    "year": 2013,
    "type": "book",
    "title": "고객네트워크전략",
    "venue": "David L. Rogers 저, 최정혜·오윤조 공역, 박영사"
  }
];

export const members: Person[] = [
  {
    "name": "김우경"
  },
  {
    "name": "황인서"
  },
  {
    "name": "나규원"
  },
  {
    "name": "김정현"
  },
  {
    "name": "오가령"
  }
];

export const alumni: Person[] = [
  {
    "name": "이예령",
    "role": "박사",
    "year": "2025",
    "destination": "고려대학교 디지털경영 교수",
    "group": "Faculty"
  },
  {
    "name": "김상화",
    "role": "석사 · University of Maryland 박사",
    "year": "2019",
    "destination": "McMaster University 마케팅 교수",
    "group": "Faculty"
  },
  {
    "name": "조우용",
    "role": "석사 · Emory University 박사",
    "year": "2017",
    "destination": "Purdue University 마케팅 교수",
    "group": "Faculty"
  },
  {
    "name": "김민경",
    "role": "학사 · Wharton School 박사",
    "year": "2015",
    "destination": "Ohio State University 마케팅 교수",
    "group": "Faculty"
  },
  {
    "name": "김지연",
    "role": "2014 석사 · 2018 박사",
    "year": "2014 · 2018",
    "destination": "La Trobe University 마케팅 교수",
    "group": "Faculty"
  },
  {
    "name": "정현우",
    "role": "석사",
    "year": "2025",
    "destination": "Wharton School 마케팅 박사과정",
    "group": "Doctoral Study"
  },
  {
    "name": "김혜정",
    "role": "석사",
    "year": "2024",
    "destination": "Georgia Institute of Technology 마케팅 박사과정",
    "group": "Doctoral Study"
  },
  {
    "name": "윤여림",
    "role": "통합",
    "year": "2023",
    "destination": "University of Minnesota 마케팅 박사과정",
    "group": "Doctoral Study"
  },
  {
    "name": "곽유신",
    "role": "석사",
    "year": "2022",
    "destination": "Emory University 마케팅 박사과정",
    "group": "Doctoral Study"
  },
  {
    "name": "윤여홍",
    "role": "석사",
    "year": "2021",
    "destination": "Emory University 마케팅 박사과정",
    "group": "Doctoral Study"
  },
  {
    "name": "송혜신",
    "role": "석사",
    "year": "2020",
    "destination": "Georgia State University 마케팅 박사과정",
    "group": "Doctoral Study"
  },
  {
    "name": "장연",
    "role": "석사",
    "year": "2018",
    "destination": "University of Houston 마케팅 박사과정",
    "group": "Doctoral Study"
  },
  {
    "name": "이지연",
    "role": "석사",
    "year": "2021",
    "destination": "롯데면세점",
    "group": "Industry"
  }
];

export const awards: TimelineRecord[] = [
  {
    "year": "2021",
    "title": "상전유통학술상 최우수학술상",
    "detail": "롯데그룹 · 한국유통학회"
  },
  {
    "year": "2021",
    "title": "연세대학교 경영대학 우수교수상"
  },
  {
    "year": "2021",
    "title": "연세대학교 우수강의교수상"
  },
  {
    "year": "2020",
    "title": "연세대학교 우수업적교수상 연구부문"
  },
  {
    "year": "2019",
    "title": "연세대학교 경영대학 우수강의상"
  },
  {
    "year": "2019",
    "title": "한국유통학회 유통연구 우수논문상"
  },
  {
    "year": "2018",
    "title": "KSMS International Conference Best Conference Paper Award"
  },
  {
    "year": "2017",
    "title": "Global Fashion Management Conference Best Conference Paper Award"
  },
  {
    "year": "2017",
    "title": "한국마케팅학회 춘계학술대회 석사과정 발표논문 우수상"
  },
  {
    "year": "2016",
    "title": "KSMS International Conference Best Conference Paper Award"
  },
  {
    "year": "2015",
    "title": "Marketing Science Institute Young Scholar"
  },
  {
    "year": "2014",
    "title": "SPC 신진경영학자상"
  },
  {
    "year": "2013",
    "title": "연세학술상 사회과학 분야"
  },
  {
    "year": "2013",
    "title": "Robert D. Buzzell MSI Best Paper Award"
  },
  {
    "year": "2012",
    "title": "연세대학교 경영대학 MBA 우수강의교수상"
  },
  {
    "year": "2011",
    "title": "초헌학술상 우수연구상"
  },
  {
    "year": "2011",
    "title": "AMA TechSIG Best Article of the Year Competition"
  },
  {
    "year": "2010",
    "title": "Fisher IMS & AMA SERVSIG Dissertation Proposal Competition Runner-up"
  },
  {
    "year": "2009",
    "title": "UTD Frontiers of Research in Marketing Conference Best Empirical Paper"
  },
  {
    "year": "2009",
    "title": "SMA Doctoral Dissertation Competition Best Retail Proposal Award"
  },
  {
    "year": "2009",
    "title": "AMA TechSIG Most Promising Dissertation Proposal Competition"
  },
  {
    "year": "2009",
    "title": "Mack Center Award"
  },
  {
    "year": "2007–2009",
    "title": "Ackoff Doctoral Student Award for Research on Human Decision Processes",
    "detail": "2007 · 2008 · 2009"
  }
];

export const supports: TimelineRecord[] = [
  {
    "year": "2025",
    "title": "중견연구자지원",
    "detail": "한국연구재단"
  },
  {
    "year": "2021–2025",
    "title": "연세 시그너처 연구클러스터",
    "detail": "연세대학교"
  },
  {
    "year": "2020–현재",
    "title": "BK21 Four",
    "detail": "한국연구재단"
  },
  {
    "year": "2011–2027",
    "title": "SSK · Social Science Korea",
    "detail": "한국연구재단 · 2011–2014, 2017–2020, 2020–2023, 2024–2027"
  },
  {
    "year": "2016–2020",
    "title": "BK21plus",
    "detail": "한국연구재단"
  },
  {
    "year": "2012–2019",
    "title": "신진연구자지원",
    "detail": "한국연구재단 · 2012–2013, 2014, 2015, 2016, 2019"
  },
  {
    "year": "2013·2014",
    "title": "상남경영원 연구펠로우십",
    "detail": "연세대학교"
  }
];

export const publicationCounts = {
  all: publications.length,
  international: publications.filter((item) => item.type === "international").length,
  domestic: publications.filter((item) => item.type === "domestic").length,
  book: publications.filter((item) => item.type === "book").length,
} as const;
